export default __webpack_public_path__ + "static/media/icon_privacy_home_transparency_icon-1.09b80ada.svg";